import Highcharts from "highcharts";
import {
  chartBackgroundColor,
  xAxisLabelStyle,
  lineColor,
  xAxisTickWidth,
  crpBarChartYAxisOptions,
  plotOptionsBarBorderColor,
  plotOptionsBarBorderWidth,
  plotOptionsBarShowInLegend,
  plotOptionsBarThreshold,
  barChartBorderRadius,
  readRiskThresholds,
} from "./globals";

document.addEventListener("turbo:load", () => {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='level_control_count']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const cmmcLevels: string[] = JSON.parse(chart.dataset.cmmcLevels!);
      const seriesData: Array<{
        y: number;
        count: number;
        max: number;
        color: string;
      }> = JSON.parse(chart.dataset.seriesData!);
      const riskThresholds = readRiskThresholds(chart);

      Highcharts.chart({
        chart: {
          renderTo: chart,
          backgroundColor: chartBackgroundColor,
          type: "bar",
          height: 130,
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            lineWidth: 0,
            labels: {
              style: xAxisLabelStyle,
            },
            lineColor: lineColor,
            tickColor: lineColor,
            categories: cmmcLevels,
            tickWidth: xAxisTickWidth,
          },
        ],
        yAxis: [crpBarChartYAxisOptions(riskThresholds)],
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            animation: false,
            borderColor: plotOptionsBarBorderColor,
            borderWidth: plotOptionsBarBorderWidth,
            borderRadius: barChartBorderRadius,
            showInLegend: plotOptionsBarShowInLegend,
            threshold: plotOptionsBarThreshold,
            groupPadding: 0.07,
          },
        },
        series: [
          {
            name: "container",
            showInLegend: false,
            animation: false,
            dataLabels: {
              enabled: true,
              format: "{point.count}/{point.max}",
              color: "{point.color}",
            },
            data: seriesData,
          },
        ],
      });
    });
  }
});
